import { convertStyle } from 'utils/Style';
import { useMemberInfo } from 'utils/State';

import promotionStyle from '../style/Promotion.module.scss';
import missionStyle from '../style/MissionEvent.module.scss';

import img_profile_default from 'assets/images/mypage/img_profile_default.png';
import { useBookpalNavigate } from 'component/common/custom/BookpalLink';
import { appSetMove, isApp } from 'utils/AppUtil';
import { useLocation } from 'react-router-dom';

const style = { ...promotionStyle, ...missionStyle };

function Profile({data, eventId}){

    const memberInfo = useMemberInfo();

    const location = useLocation();
    const navigate = useBookpalNavigate();

    const queryString = location.search.startsWith("?") ? location.search.substring(1) : location.search;


    return (
        <div className={convertStyle(style, "myInfo radius-xxl white-always bg")}>
            <div className={convertStyle(style, "profile_box left ")}>
                <span className={convertStyle(style, "profile radius-full ")}>
                    <img src={data?.profile_image ?? img_profile_default} style={{minWidth:"100%"}} />
                </span>
            </div>
            <div className={convertStyle(style, "right ")}>
                {/* <!-- 로그인 전 --> */}
                {!memberInfo?.is_login ? 
                <div className={convertStyle(style, "before")} >
                    <button 
                        type="button" 
                        className={convertStyle(style, "login_btn button")}
                        onClick={()=>{
                            if(isApp()){
                                // appSetMove("", "nbp://login?app_return_link="+location.pathname+encodeURIComponent("?")+queryString);
                                appSetMove("", "nbp://login");
                                return;
                            }
                            navigate("/login",{state:{return_path:location.pathname, return_query:queryString}});
                        }}
                        >
                        <span className="title-02-b">로그인 하고 미션참여하기</span>
                    </button>
                </div>
                :null}
                {/* <!-- 로그인 후 --> */}
                {memberInfo?.is_login ? 
                <div className={convertStyle(style, "after ")} style={{display: "block"}}>
                    <div className={convertStyle(style, "name text_overflow title-02-b ")}>{data?.mb_nick}</div>
                    <div className={convertStyle(style, "completedMisson ")}>
                        <p className={convertStyle(style, "txt body-03 ")}>완료된 미션</p>
                        <p className={convertStyle(style, "num ")}>
                            <span className={convertStyle(style, "title-01-b profile_red")} >{data?.cnt_success ?? 0}</span>
                            <span className={convertStyle(style, "body-03-long profile_gray")} >/</span>
                            <span className="title-01-b">{data?.cnt_mission ?? 0}</span>
                            <span className="body-03">개</span>
                        </p>
                    </div>
                </div>
                :null}
            </div>
        </div>
        
    )
}

export default Profile;